module.exports = __webpack_public_path__ + "img/premium-img-2.30557acc.png";